import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DELETE_URL, IFileDelete } from '@ui-app/models/common.models';

@Injectable()
export class S3DeleteService implements IFileDelete {

    constructor(
        @Optional() @Inject(DELETE_URL) private deleteUrl: string,
        private httpClient: HttpClient,
    ) {}

    deleteFile(uId: string): Observable<null> {
        const url = this.deleteUrl.replace('{uId}', uId);
        return this.httpClient.post(url, {}) as Observable<null>;
    }

}
